import { useRef, useState } from "react";
import Icon from "../../../a-atoms/icons/Icon";
import style from "./Input.module.css";

const Input = (props) => {
  const [type, setType] = useState(props.type);
  const inputRef = useRef();

  function show() {
    inputRef.current.focus();
    setType("text");
  }
  function hide() {
    inputRef.current.focus();
    setType("password");
  }
  return (
    <div className={`${style.inputContainer} ${props.error && style.error} ${
      props.variants ? props.variants.map((i) => style[i]).join(" ") : null
    } ${!props.label && style.noLabel}`}>
      <div className={style.container}>
        {props.type === "password" ? (
          type === "password" ? (
            <Icon onClick={show}>visibility_off</Icon>
          ) : (
            <Icon onClick={hide}>visibility</Icon>
          )
        ) : null}
        <input
          ref={inputRef}
          type={type}
          value={props.value}
          placeholder={props.placeholder}
          onChange={props.onChange}
        />
        {props.label ? <label>{props.label}</label> : null}
        {/* <label>{props.label}</label> */}
      </div>
      <div className={style.helper}>{props.error? props.error : props.helper}</div>
    </div>
  );
};

export default Input;
